export default __webpack_public_path__ + "static/media/espresso.a4fc760e.jpg";